import { render } from "./Sanigen.vue?vue&type=template&id=53e8d86c&scoped=true"
import script from "./Sanigen.vue?vue&type=script&lang=js"
export * from "./Sanigen.vue?vue&type=script&lang=js"

import "./Sanigen.vue?vue&type=style&index=0&id=53e8d86c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e8d86c"]])

export default __exports__